import { useEffect } from 'react';
import { OpenFeature } from '@openfeature/web-sdk';
import { useAppSelector } from '../hooks';
import { selectUserId } from '../containers/Login/LoginSlice';
import { selectTenantId } from '../containers/Organizations/OrganizationsSlice';
import { ensureFeatureFlagsProvider } from './setup';

/**
 * Keeps the OpenFeature evaluation context aligned with auth / tenant state.
 * Renders nothing; mount inside {@link OpenFeatureProvider} and Redux `Provider`.
 */
function FeatureFlagsSync(): null {
  const userId = useAppSelector(selectUserId);
  const tenantId = useAppSelector(selectTenantId);

  useEffect(() => {
    let cancelled = false;

    // Align the provider with the current region (idempotent: rebinds only on
    // region change, so same-region auth changes never tear down the provider
    // and synchronous flag reads stay truthful — see ensureFeatureFlagsProvider).
    void ensureFeatureFlagsProvider().then(() => {
      // Guard against rapid userId/tenantId changes: discard stale callbacks
      // so a slow setup never overwrites context set by a later effect run.
      if (!cancelled) {
        OpenFeature.setContext({
          userId: String(userId),
          tenantId: String(tenantId),
          organizationId: String(tenantId),
        }).catch(error =>
          console.error('Failed to set OpenFeature context', { userId, tenantId, error })
        );
      }
    });

    return () => {
      cancelled = true;
    };
  }, [userId, tenantId]);

  return null;
}

export default FeatureFlagsSync;
